import React from 'react';
import error from '../assets/images/error.png';

function NotFound(props) {
    return (
        <section style={{ padding: '20px 0' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-8 text-center">
                        <img
                            src={error}
                            alt="Back To Home Error img"
                            className="img-fluid"
                        />
                        <h1>Oops!</h1>
                        <p>Page Not Found</p>
                        <a
                            className="btn btn-primary"
                            href="/"
                        >
                            {' '}
                            Back To Home{' '}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default NotFound;
